import { GuidValidationResponse, DigitalOnboardingModel, UpdateGuid } from '../models/guid-validation-response.model';
import { Customer } from '../models/customer.model';
import { HttpClient } from '@angular/common/http';
import { Claim, ScriptingAgreedModel } from '../models/claim.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ClaimsService {
    constructor(private http: HttpClient) { }

    loadClaim(ref: string): Observable<Claim> {
        return this.http.get<Claim>(`claims/${ref}`);
    }

    saveClaim(claim: Claim, customer: Customer): Observable<Claim> {
        claim.updatedBy = customer.emailAddress;        
        return this.http.post<Claim>(`claims`, claim);
    }

    loadCustomer(customerId: number): Observable<Customer> {
        return this.http.get<Customer>(`customer/${customerId}`);
    }

    saveCustomer(customer: Customer): Observable<Customer> {
        customer.updatedBy = customer.emailAddress;
        return this.http.post<Customer>(`customer`, customer);
    }

    saveClaimSummary(claimReference: string): Observable<string> {
        return this.http.post<string>(`claims/summary/${claimReference}`, null);
    }  

    updateScriptingAgreedModel(claimReference: string, scriptingAgreedModel: ScriptingAgreedModel): Observable<ScriptingAgreedModel> {
        return this.http.post<ScriptingAgreedModel>(`claims/scripting-model/${claimReference}`, scriptingAgreedModel);
    } 

    validateGuid(guid: string): Observable<GuidValidationResponse> {
        return this.http.get<GuidValidationResponse>(`digitalonboarding/validate/${guid}`);
    }

    loadGuid(ref: string): Observable<DigitalOnboardingModel> {
        return this.http.get<DigitalOnboardingModel>(`digitalonboarding/${ref}`);
    }

    updateGuid(updateGuid: UpdateGuid): Observable<string> {
        return this.http.put<string>(`digitalonboarding`, updateGuid)
    }
}


